/** Helpers for the eject "Site Ready & Ejected" UI (clone screen + ejected card). */

/** Derive the repo directory name (the `git clone` target dir) from the repo URL. */
export function repoNameFromUrl(url: string): string {
  const last = url.replace(/\/+$/, '').split('/').pop() ?? '';
  return last.replace(/\.git$/, '');
}

/** The 1-click local-setup command shown after an eject.
 *  NOTE: `npm install`, not `npm ci` — the ejected repo intentionally ships no
 *  package-lock.json (same reason its CI uses npm install), so `npm ci` would fail. */
export function cloneCommand(repoUrl: string): string {
  const name = repoNameFromUrl(repoUrl);
  return `mkdir -p ~/Aviv-MCS-Workspace && cd ~/Aviv-MCS-Workspace && git clone ${repoUrl} && cd ${name} && npm install`;
}
